export { default } from './DetailsModal';
